import { Button } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from 'common/typography';

import {
  ScreenCenteredImage,
  ScreenContainer,
  ScreenInformation,
  ScreenHeader,
  ScreenActionsContainer,
} from './screens.styled';
import SuccessImage from '../../../images/success.png';

export const Success = ({ onBack }: { onBack: () => void }) => (
  <ScreenContainer>
    <ScreenCenteredImage src={SuccessImage} />
    <ScreenInformation>
      <ScreenHeader>
        <FormattedMessage id="insights.reports.result.success.title" />
      </ScreenHeader>
      <Typography.Body3>
        <FormattedMessage id="insights.reports.result.success.description" />
      </Typography.Body3>
    </ScreenInformation>
    <ScreenActionsContainer>
      <Button variant="primary" size="small" onClick={onBack}>
        <FormattedMessage id="insights.reports.result.back-to-insights" />
      </Button>
    </ScreenActionsContainer>
  </ScreenContainer>
);
